// Value cells are edited and pasted in dollars (what formatNumber displays).
// Thousands separators/whitespace are stripped; the decimal point is kept.
// Empty input clears the cell; unparseable input returns undefined (ignored).
export const parseEditedDollars = (raw: unknown): number | null | undefined => {
    if (raw === null || raw === undefined) return null;
    if (typeof raw !== "string" && typeof raw !== "number") return undefined;
    const text = String(raw).trim();
    if (text === "") return null;
    const cleaned = text.replace(/[,\s]/g, "");
    if (!/^-?\d+(\.\d+)?$/.test(cleaned)) return undefined;
    return Number(cleaned);
};
